import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {RiskConfiguration} from '../../../../shared/interface/risk-configuration';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {catchError, mapTo, tap} from 'rxjs/operators';
import {Uuid} from '../../../../shared/interface/response/uuid';
import {of} from 'rxjs';
import {RiskService} from '../../../../shared/services/risk.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {InsuranceCompany} from '../../../../shared/interface/insurance-company';
import {HttpErrorResponse} from "@angular/common/http";

export interface EditRiskModalData {
  riskConfiguration: RiskConfiguration;
}

@Component({
  selector: 'app-edit-risk-modal',
  templateUrl: './edit-risk-modal.component.html',
  styleUrls: ['./edit-risk-modal.component.scss']
})
export class EditRiskModalComponent implements OnInit {

  riskConfigurationObject: RiskConfiguration;
  riskForm: FormGroup;
  importerControl: FormControl;
  insuranceCompanyControl: FormControl;
  internalRiskControl: FormControl;
  processingRequest = false;
  selectedInsuranceCompany: InsuranceCompany;

  constructor(
    public dialogRef: MatDialogRef<EditRiskModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditRiskModalData,
    private fb: FormBuilder,
    private riskService: RiskService,
    private snack: MatSnackBar,
  ) {
    this.riskConfigurationObject = data.riskConfiguration;
    this.selectedInsuranceCompany = data.riskConfiguration.insuranceCompany;
    this.riskForm = fb.group({
      importer: this.importerControl = fb.control(null),
      insuranceCompany: this.insuranceCompanyControl = fb.control('', [Validators.required]),
      internalRisk: this.internalRiskControl = fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.riskForm.setValue({
      importer: this.riskConfigurationObject?.importer?.id ?? '',
      insuranceCompany: this.riskConfigurationObject?.insuranceCompany?.id ?? '',
      internalRisk: this.riskConfigurationObject?.internalRisk?.id ?? '',
    });
  }

  save(): void {
    this.processingRequest = true;

    this.riskService
      .sendForm(
        this.riskForm.value,
        this.riskConfigurationObject.uuid
      )
      .pipe(
        tap(() => {
          this.processingRequest = false;
        }),
        tap((response: Uuid) => {
          this.dialogRef.close(response.uuid);
        }),
        mapTo('Pomyślnie zaktualizowano konfigurację'),
        catchError((error: HttpErrorResponse) => {
          this.processingRequest = false;

          const backendErrors = error.error?.error?.list;

          if (backendErrors?.internalRisk) {
            this.internalRiskControl.setErrors({
              backend: backendErrors.internalRisk[0]
            });
          }

          return of(
            error.error?.error?.text?.trim()
            ?? 'Podczas przesyłania formularza wystąpił błąd'
          );
        })
      )
      .subscribe((message: string) => {
        this.snack.open(message.trim(),
          '',
          {
            duration: 4000,
          }
        );
      });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  insuranceCompanyChanged(
    insuranceCompany: InsuranceCompany
  ): void {
    const previousInsuranceCompanyId = this.selectedInsuranceCompany?.id;
    this.selectedInsuranceCompany = insuranceCompany;
    if (previousInsuranceCompanyId && previousInsuranceCompanyId !== insuranceCompany?.id) {
      this.importerControl.setValue(null);
    }
  }
}
